import { faGiftCard } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LinkBtn } from 'components/link-btn';
import React, { useContext } from 'react';
import { createStyles } from 'utils/createStyle';
import GiftCardImg from '../../../media/images/gift-card.png';
import { ProductGiftDetailsContext } from './ProductGiftDetails';

const styles = createStyles({
    gridGiftDetails: 'block md:flex gap-2 flex-row pt-5',
    dataGrid: [
        'text-sm grid gap-x-2',
        {
            gridTemplateColumns: 'min-content auto',
        },
    ],
    group: 'text-grey-1 text-right font-semibold',
    subGroup: 'text-grey-2 text-right truncate',
    value: 'text-left text-grey-2 text-brand',
    editBtn: ['mr-2 flex items-center justify-end md:justify-start', { marginLeft: '1.4rem' }],
});

export const GiftDetails = () => {
    const { formData, selectedDate, setIsEditing, giftCardImageUrl } =
        useContext(ProductGiftDetailsContext);

    const giftDetailsValues = [
        {
            name: 'Delivery',
            fields: [
                {
                    name: 'Date',
                    value: (selectedDate || new Date()).toLocaleDateString(),
                },
            ],
        },
        {
            name: 'Recipient',
            fields: [
                { name: 'Name', value: formData.RecipientName },
                { name: 'E-mail', value: formData.RecipientEmail },
            ],
        },
        {
            name: 'Sender',
            fields: [
                { name: 'Name', value: formData.SenderName },
                { name: 'Phone Number', value: formData.SenderPhone },
            ],
        },
    ];

    return (
        <section>
            <div className="grid grid-cols-2">
                <div className="text-brand-dark text-2xl text-left">Gift Details</div>
                <div className={styles.editBtn}>
                    <LinkBtn
                        onClick={() => setIsEditing(true)}
                        className="text-brand text-sm block underline hover:no-underline"
                    >
                        <FontAwesomeIcon
                            icon={faGiftCard}
                            style={{ fontSize: '15px' }}
                            className="mr-1"
                        />
                        <span>Edit</span>
                    </LinkBtn>
                </div>
            </div>
            <div className={styles.gridGiftDetails}>
                <div>
                    <img src={giftCardImageUrl || GiftCardImg} />
                </div>
                <div className="mt-2 md:mt-0">
                    <div className={styles.dataGrid}>
                        {giftDetailsValues.map((group) => (
                            <>
                                <div className={styles.group}>{group.name}</div>
                                <div></div>
                                {group.fields.map((field) => (
                                    <>
                                        <div className={styles.subGroup}>{field.name}</div>
                                        <div className={styles.value}>{field.value}</div>
                                    </>
                                ))}
                                <div className="col-span-2 my-1"></div>
                            </>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};
